/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.addAutoComplete = function($input) {
  // Guard against re-entrant init: initAddressPickersOnLoad fires on both
  // DOMContentLoaded and turbo:load, so this can run twice per input. Without
  // this guard a second Autocomplete instance (and a second place_changed
  // listener) is bound, firing updateUI() and address writes twice (MVP-4194).
  const existing = $input.data('autocomplete');
  if (existing) {
    return existing;
  }

  let t;
  const viewport = $input.data('viewport');
  const types = $input.data('types');
  const $address = $input.closest('.address');

  if (undefined !== types) {
    t = types.split(",");
    if (t.length < 1) {
      t = ["geocode"];
    }
  } else {
    t = ["geocode"];
  }

  // FIXME this should not be restricted!
  const options = {
    types: t,
    componentRestrictions: { country: ['us', 'ca'] }
  };

  if (viewport && (viewport.length > 1)) {
    const defaultBounds = new google.maps.LatLngBounds(new google.maps.LatLng(viewport[1][1], viewport[1][0]),
                                                 new google.maps.LatLng(viewport[0][1], viewport[0][0]));
    options['bounds'] = defaultBounds;
  }

  const autocomplete = new google.maps.places.Autocomplete($input[0], options);
  $input.data('autocomplete', autocomplete);
  autocomplete.addListener('place_changed', function() {
    const place = autocomplete.getPlace();
    $input.val(place.formatted_address || place.name);
    if ($address.length > 0) {
      cancelEditAddress($address);
      setAddressLocation($address, place);
    }
    updateUI();
  });
  return autocomplete;
};

root.initAddressPickers = function() {
  // HACK See https://github.com/ftlabs/fastclick/pull/347
  $(document).on({
    DOMNodeInserted() {
      $(".pac-item, .pac-item span", this).addClass("needsclick");
    }
  }
  , ".pac-container");
  // END HACK

  return $('.address-picker').each(function() { return addAutoComplete($(this)); });
};

/*
$(function() {
  if ($('.address-picker').length) {
    return initAddressPickers();
  }
});
*/
function initAddressPickersOnLoad() {
  if ($('.address-picker').length) {
    initAddressPickers();
  }
}

$(initAddressPickersOnLoad);
document.addEventListener('turbo:load', initAddressPickersOnLoad);

